// Public demo: list the shared logins under the login form; clicking one fills the form.
frappe.ready(() => {
	if (!window.location.pathname.startsWith("/login")) return;

	frappe.call({ method: "hms_demo.demo.get_demo_logins", type: "GET" }).then((r) => {
		const demo = r && r.message;
		const form = document.querySelector(".login-content.page-card") || document.querySelector(".page-card");
		if (!demo || !form || document.querySelector(".cnc-demo-logins")) return;

		const panel = document.createElement("div");
		panel.className = "cnc-demo-logins page-card";
		panel.innerHTML = `
			<div class="cnc-demo-title">${__("Try the demo")}</div>
			<div class="cnc-demo-hint">${__("Pick a role to sign in. Password for all")}: <code>${frappe.utils.escape_html(demo.password)}</code></div>
			<div class="cnc-demo-list"></div>
			<div class="cnc-demo-note">${__("Sample data only. The demo resets every night.")}</div>`;

		const list = panel.querySelector(".cnc-demo-list");
		demo.logins.forEach((login) => {
			const btn = document.createElement("button");
			btn.type = "button";
			btn.className = "cnc-demo-login";
			btn.innerHTML = `<span>${frappe.utils.escape_html(login.label)}</span><small>${frappe.utils.escape_html(login.email)}</small>`;
			btn.addEventListener("click", () => {
				$("#login_email").val(login.email).trigger("change");
				$("#login_password").val(demo.password).trigger("change");
				$(".btn-login").trigger("click");
			});
			list.appendChild(btn);
		});

		form.insertAdjacentElement("afterend", panel);
	});
});
